export default __webpack_public_path__ + "static/media/album.9b3b1838.svg";